// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"cb062b64","701":"360a1e98"}[chunkId] + ".chunk.css";
};